import { render, staticRenderFns } from "./AdminCustomerDetail.vue?vue&type=template&id=59063591&scoped=true&"
import script from "./AdminCustomerDetail.vue?vue&type=script&lang=ts&"
export * from "./AdminCustomerDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCustomerDetail.vue?vue&type=style&index=0&id=59063591&scoped=true&lang=css&"
import style1 from "./AdminCustomerDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59063591",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VChip,VDataTable,VIcon,VSelect,VTextField})
